import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="container footer-grid">
          <div className="footer-brand-col">
            <Link to="/" className="footer-brand">
              <span className="footer-brand-icon">
                <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                  <path d="M12 2C12 2 5 9.5 5 14a7 7 0 0 0 14 0C19 9.5 12 2 12 2z"/>
                </svg>
              </span>
              <span>Blood<span>Bridge</span></span>
            </Link>
            <p className="footer-tagline">
              Connecting donors with those in need.<br />
              Every drop of blood is a gift of life.
            </p>
            <div className="footer-emergency">
              <span className="footer-emergency-label">Emergency</span>
              <a href="tel:+919876543210" className="footer-emergency-number">+91 98765 43210</a>
            </div>
          </div>

          <div className="footer-nav-col">
            <h4>Navigation</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
              <li><Link to="/admin">Admin Portal</Link></li>
            </ul>
          </div>

          <div className="footer-nav-col">
            <h4>Blood Groups</h4>
            <div className="footer-blood-groups">
              {['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-'].map(g => (
                <span key={g} className="footer-bg-tag">{g}</span>
              ))}
            </div>
          </div>

          <div className="footer-nav-col">
            <h4>Why Donate?</h4>
            <ul className="footer-facts">
              <li>1 donation saves up to 3 lives</li>
              <li>Blood cannot be manufactured</li>
              <li>Someone needs blood every 2 seconds</li>
              <li>Only 7% of people have O- blood</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container footer-bottom-inner">
          <p>© {year} BloodBridge by MS Discoveries. All rights reserved.</p>
          <p className="footer-built">
            Built with purpose — <span>saving lives, one donor at a time.</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
